import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { AuthenticateService } from '@fi-app/utilities/fi-services/authenticate.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiAuthenticateHelperService } from '@fi-shared/fi-auth-shared/fi-authenticate-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { ForgotPasswordMultipleContactsComponent } from '@fi-app/authenticate/login-help/forgot-password-multiple-contacts/forgot-password-multiple-contacts.component';
import { MagicLinkDeliveryType } from '@fi-shared/types/magic-link-delivery-type';
import { ICustomerUserInfo } from '@fi-shared/fi-shared-interfaces';

export enum FiUserLoginHelpType {
    ResetPassword = 1,
    Other = 2,
}

@Component({
    selector: 'fi-authenticate-login-help',
    templateUrl: './login-help.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['../authenticate.scss', './login-help.component.scss'],
    host: { class: 'fi-authenticate-login-help' },
    standalone: false,
})
export class FiAuthenticateLoginHelpComponent implements OnInit {
    @Input() userCountryId: number;
    helpType: FiUserLoginHelpType = FiUserLoginHelpType.ResetPassword;
    userLoginOrContact: string = '';

    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private authenticateService: AuthenticateService,
        private authenticateHelper: FiAuthenticateHelperService,
        private stateService: FiStateService,
        private supportService: FiSupportService,
        private customerDataService: FiCustomerDataService,
    ) {}

    ngOnInit(): void {
        /*this.userLoginOrContact = 'do011279ndj@gmail.com';
        this.userLoginOrContact = 'mattias@gmail.com';
        this.forgotPassword();*/
        // for tests
    }

    proceed($event: MouseEvent) {
        $event.preventDefault();

        switch (this.helpType) {
            case FiUserLoginHelpType.ResetPassword:
                this.forgotPassword();
                break;
            case FiUserLoginHelpType.Other:
                //Go to "other"
                this.checkCustomerSupport();
                break;
            default:
                this.fiDialogsService.error({
                    messageText: this.appTextService.get('login.select_error'),
                });
                break;
        }
    }

    private checkCustomerSupport() {
        if (!this.customerDataService.getSupportEmailAddress()) {
            this.supportService.showSupportContactMissingDialog();
        } else {
            this.stateService.go(FiStateNames.Login.HelpOther);
        }
    }

    private createResetPasswordLink(userId: number, userContact: string, deliveryType: MagicLinkDeliveryType) {
        this.authenticateService.createResetPasswordLink(userId, userContact).then(() => {
            this.authenticateHelper.showMagicLinkSentDialog(userContact, deliveryType);
        });
    }

    private forgotPassword() {
        const userContact: string = this.authenticateHelper.handleUserLoginNumber(this.userLoginOrContact);

        this.authenticateService.getUsersForForgotPassword(userContact).then((response: ICustomerUserInfo[]) => {
            if (response.length === 1) {
                const userInfo = response[0];
                if (userInfo.Contacts.length === 1) {
                    const contact = userInfo.Contacts[0];
                    this.createResetPasswordLink(contact.UserId, contact.ContactValue, contact.DeliveryType);
                } else {
                    this.fiDialogsService
                        .custom({
                            headerText: this.appTextService.get('auth.reset_password') + '?',
                            headerIconClass: 'fa-regular fa-arrow-rotate-right BrandedColor',
                            isTopCloseButtonShown: true,
                            contentComponentRef: ForgotPasswordMultipleContactsComponent,
                            contentComponentData: userInfo,
                            yesButtonText: this.appTextService.get('auth.reset_password'),
                            config: {
                                panelClass: 'fi-rounded-dialog-panel',
                            },
                        })
                        .onYesButtonClick((result) => {
                            this.createResetPasswordLink(result.UserId, result.ContactValue, result.DeliveryType);
                        });
                }
            } else {
                this.fiDialogsService.error({
                    messageText: this.appTextService.get('auth.user_not_found_login_email_text'),
                    headerText: this.appTextService.get('auth.user_not_found_login_email_header'),
                });
            }
        });
    }

    isProceedDisabled(): boolean {
        return this.isResetPasswordHelp() && !this.userLoginOrContact?.length;
    }

    isResetPasswordHelp(): boolean {
        return this.helpType === FiUserLoginHelpType.ResetPassword;
    }

    readonly FiUserLoginHelpType = FiUserLoginHelpType;
}
